<template>
  <div class="sign-up-container c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit.prevent="handleSignUp">
                  <h3 class="text-center text-underline mb-4">みまもりサービスBASICプランのアカウント登録</h3>
                  <h5 class="mb-3">
                    みまもりサービスBASICプランのアカウントを新規作成します。
                    <br/>氏名と、パスワードを入力してください。
                  </h5>
                  <CInput
                    id="username"
                    label="あなたの氏名"
                    autocomplete="username email"
                    :class="{'error-fields': hasError && username.trim() === ''}"
                    v-model="username"
                  >
                  </CInput>
                  <CInput
                    id="password"
                    label="パスワード"
                    type="password"
                    autocomplete="curent-password"
                    :class="{'error-fields': hasError}"
                    v-model="password"
                  >
                  </CInput>
                  <CRow class="mb-2" v-if="hasError">
                    <CCol col="12" class="text-center">
                      <div class="error">
                        <span>{{ errorMsg }}</span>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="12" class="text-center">
                      <CButton type="submit" color="primary" class="px-4 sign-up-button">アカウントを作成する</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
  name: 'Login',

  data () {
    return {
      username: '',
      password: '',
      hasError: false,
      errorMsg: ''
    }
  },

  methods: {
    checkFields () {
      if (this.username.trim() === '') {
        this.hasError = true
        this.errorMsg = '氏名が入力されていません'
        return false
      }

      if (this.password.trim() === '' || this.password.trim().length < 8) {
        this.hasError = true
        this.errorMsg = 'パスワードは8文字以上で入力してください'
        return false
      }

      this.hasError = false
      return true
    },

    handleSignUp () {
      try {
        let check = this.checkFields()

        if (!check) {
          return
        }

        window.location.href = this.$mimamoriBaseUrl + '/dashboard'
      } catch (err) {
        this.hasError = true
        this.errorMsg = err.message
      }
    }
  }
}
</script>